/**
 * Format a numeric listener count into a human-readable string.
 * Examples: 0 → "0", 500 → "500", 1200 → "1.2K", 15000 → "15K", 1500000 → "1.5M"
 */
export function formatListenerCount(count: number | null | undefined): string {
    if (count == null || count <= 0) return '0';
    
    if (count >= 1_000_000) {
        const m = count / 1_000_000;
        return m % 1 === 0 ? `${m}M` : `${m.toFixed(1).replace(/\.0$/, '')}M`;
    }
    
    if (count >= 1_000) {
        const k = count / 1_000;
        return k % 1 === 0 ? `${k}K` : `${k.toFixed(1).replace(/\.0$/, '')}K`;
    }
    
    return count.toString();
}
